module.exports = __webpack_public_path__ + "static/media/bullseye-arrow.91709f8d.svg";